import * as React from 'react';
import { ReactReduxContext, useDispatch } from 'react-redux';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { BookmarkSelectItem, selectBookmark, selectBookmarkAdd, selectRecommendationItem, inMeetingSearch } from '../../store/Meeting/actions';
import { Bookmark } from '../../store/Story/modal';
import styles from './sidepanel-Item.module.scss';
import SidepanelFileItem from './sidepanel-fileItem';

const BookmarkSidepanelItem = ({
    id,
    name,
    files,
    thumbnail,
    storyId
}: Bookmark) => {

    let checked = false;
    

    const dispatch = useDispatch();
    const metaData = `${files.length} Files`;
    const {
        currentMeeting,
        selectedFiles,
        currentBookmarkSelection,
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const currentFileitem = selectedFiles.find(c=>c.id === id);
    if(currentFileitem) {
        checked = currentFileitem.checked;
    }

    const isAlreadyAdded = !!currentMeeting.meetingContents.find(c=>c.storyId === storyId);
    const onItemCheckedChanged = (fileId: number, checked: boolean) => {
        dispatch(selectBookmarkAdd(id, files.map(c=>{
            return {
                id: c.id,
                storyId: c.permId,
                checked: false,
            }
        })))

        files.forEach(function (currentFile) {
            if (!checked) {
                var index = currentBookmarkSelection.indexOf(currentFile.id)
                if (index !== -1) {
                    currentBookmarkSelection.splice(index, 1);
                }
            }
            else {
                currentBookmarkSelection.push(currentFile.id)
            }

        })
        
        dispatch(inMeetingSearch("", currentBookmarkSelection));
        dispatch(BookmarkSelectItem(storyId, id, checked));
    };
    
    return (
        <div className={styles.root}>
            <SidepanelFileItem
                category={''}
                onCheckedChange={()=>{}}
                onCheckedItemChange ={onItemCheckedChanged}
                showChecked={true}
                disable={isAlreadyAdded}
                checked={checked || isAlreadyAdded}
                onItemClick={()=>{}}
                metaData={metaData}
                id={id}
                title={name}
                description ={files[0].description}
                thumbnail={thumbnail} />
        </div>
    )
};

export default BookmarkSidepanelItem